import React, {useCallback, useState} from 'react';
import {Box, Fade, Modal, Typography} from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import {global, input, sip} from "../translate";
import CloseIcon from "@mui/icons-material/Close";
import Api from "../Api";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: window.innerWidth > 400 ? 400 : window.innerWidth,
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    // height: window.innerWidth > 600?'50vh':'97vh',
    overflow: 'auto'
};

function ChooseEmotion({r, handleText,open,setOpen}) {
    const [l,setL] = useState('')
    const [loader,setLoader] = useState(false)
    const handleSelect = useCallback(async (e) => {
        setLoader(true)
        if(l === 'hy'){
            const {data} = await Api.createHy(open.uniqueid || open.id)
            if(data.data.success){
                handleText({...open,isEmotion:{via:'hy',}})
            }

        }else{
            const {data} = await Api.getEmotions(open.uniqueid || open.id);
            handleText({...open,isEmotion:{via:'emotion',}})
        }
        setLoader(false)
        setOpen(null)
    },[l,open])

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            slots={{backdrop: Backdrop}}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={open}>
                <Box sx={style}>
                    <div className="d-flex flex-row justify-content-between">
                        <Typography id="transition-modal-title" variant="h6" component="h2">
                            Choose Language
                        </Typography>
                        <span style={{cursor: 'pointer'}} onClick={() => setOpen(false)}>
                            <CloseIcon/>
                        </span>
                    </div>

                    <div>
                        <select style={{width: '100%', height: 40, margin:'20px 0'}} value={l} onChange={(ev) => setL(ev.target.value)}>
                            <option value="">{input.select[+localStorage.getItem('atsLang') || 1]}</option>
                            <option value="hy">Հայերեն</option>
                            <option value="en">English</option>
                        </select>

                        <button onClick={handleSelect} className="addBtn">
                            {loader?"Loading...":global.createUrs[+localStorage.getItem('atsLang')  || 1]}
                        </button>
                    </div>

                </Box>
            </Fade>
        </Modal>
    );
}

export default ChooseEmotion;
